<template>
    <div id="top">
        <div id="wrap_all">
            <header
                id="header"
                class="all_colors header_color light_bg_color av_header_top av_logo_left av_main_nav_header av_menu_right av_slim av_header_sticky av_header_shrinking_disabled av_header_stretch av_mobile_menu_tablet av_header_searchicon_disabled av_header_unstick_top_disabled av_minimal_header av_bottom_nav_disabled av_header_border_disabled"
                role="banner"
                itemscope="itemscope"
                itemtype="https://schema.org/WPHeader"
            >
                <div
                    id="header_main"
                    class="container_wrap container_wrap_logo"
                >
                    <div class="container av-logo-container">
                        <div class="inner-container">
                            <span class="logo"
                                ><a href="/"
                                    ><!--?xml version="1.0" encoding="utf-8"?-->
                                    <!-- Generator: Adobe Illustrator 24.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                                    <svg
                                        version="1.1"
                                        id="Warstwa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 595.28 99.6"
                                        style="
                                            enable-background: new 0 0 595.28
                                                99.6;
                                        "
                                        xml:space="preserve"
                                    >
                                        <style type="text/css">
                                            .st0 {
                                                fill: #002244;
                                            }
                                        </style>
                                        <g>
                                            <path
                                                class="st0"
                                                d="M55.81,78.12v19.53H0V83.7l26.37-36.27H1.4V27.9h53.01v13.95L28.04,78.12H55.81z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M135.77,27.9v69.75h-20.93V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83
          c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V27.9H135.77z M114.84,62.77c0-10.46-6.97-17.02-16.6-17.02
          s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S114.84,73.24,114.84,62.77z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M222.72,0v97.65H201.8V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83
          c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V0H222.72z M201.8,62.77c0-10.46-6.97-17.02-16.6-17.02
          s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S201.8,73.24,201.8,62.77z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M313.17,62.77c0,20.79-15.07,36.83-33.34,36.83c-9.35,0-16.18-3.21-20.79-8.51v6.55h-20.92V0h20.92v34.46
          c4.61-5.3,11.44-8.51,20.79-8.51C298.1,25.95,313.17,41.99,313.17,62.77z M292.24,62.77c0-10.46-6.97-17.02-16.6-17.02
          s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S292.24,73.24,292.24,62.77z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M396.64,27.9v69.75h-20.93V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83
          c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V27.9H396.64z M375.71,62.77c0-10.46-6.97-17.02-16.6-17.02
          s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02C368.74,79.8,375.71,73.24,375.71,62.77z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M478.98,54.82v42.83h-20.92V57.9c0-8.65-5.44-12.7-12.14-12.7c-7.67,0-12.98,4.46-12.98,14.37v38.09h-20.92
          V27.9h20.92v6.55c3.77-5.16,10.75-8.51,19.95-8.51C466.99,25.95,478.98,35.99,478.98,54.82z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M489.91,62.77c0-20.78,16.46-36.83,36.97-36.83s36.97,16.04,36.97,36.83S547.39,99.6,526.88,99.6
          C506.37,99.61,489.91,83.56,489.91,62.77z M542.92,62.77c0-9.9-6.98-16.46-16.04-16.46c-9.07,0-16.04,6.55-16.04,16.46
          s6.97,16.46,16.04,16.46C535.94,79.24,542.92,72.68,542.92,62.77z"
                                            ></path>
                                            <path
                                                class="st0"
                                                d="M568.77,86.35c0-7.25,6-13.25,13.26-13.25c7.25,0,13.25,6,13.25,13.25c0,7.26-6,13.26-13.25,13.26
          C574.77,99.61,568.77,93.61,568.77,86.35z"
                                            ></path>
                                        </g></svg></a
                            ></span>
                            <nav
                                class="main_menu"
                                data-selectname="Wybierz stornę"
                                role="navigation"
                                itemscope="itemscope"
                                itemtype="https://schema.org/SiteNavigationElement"
                            >
                                <div class="avia-menu av-main-nav-wrap">
                                    <ul id="avia-menu" class="menu av-main-nav">
                                        <li
                                            id="menu-item-47"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-1"
                                        >
                                            <a
                                                href="https://zadbano.pl/o-nas/"
                                                itemprop="url"
                                                ><span
                                                    class="avia-bullet"
                                                ></span
                                                ><span class="avia-menu-text"
                                                    >O nas</span
                                                ><span class="avia-menu-fx"
                                                    ><span
                                                        class="avia-arrow-wrap"
                                                        ><span
                                                            class="avia-arrow"
                                                        ></span></span></span
                                            ></a>
                                        </li>
                                        <li
                                            id="menu-item-48"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-top-level menu-item-top-level-2 dropdown_ul_available"
                                        >
                                            <a
                                                href="#"
                                                itemprop="url"
                                                style="cursor: default"
                                                ><span
                                                    class="avia-bullet"
                                                ></span
                                                ><span class="avia-menu-text"
                                                    >Oferta dla biznesu</span
                                                ><span class="avia-menu-fx"
                                                    ><span
                                                        class="avia-arrow-wrap"
                                                        ><span
                                                            class="avia-arrow"
                                                        ></span></span></span
                                                ><span
                                                    class="dropdown_available"
                                                ></span
                                            ></a>

                                            <ul
                                                class="sub-menu"
                                                style="
                                                    display: block;
                                                    opacity: 0;
                                                    visibility: hidden;
                                                "
                                            >
                                                <li
                                                    id="menu-item-51"
                                                    class="menu-item menu-item-type-post_type menu-item-object-page"
                                                >
                                                    <a
                                                        href="https://zadbano.pl/uslugi/"
                                                        itemprop="url"
                                                        ><span
                                                            class="avia-bullet"
                                                        ></span
                                                        ><span
                                                            class="avia-menu-text"
                                                            >Usługi</span
                                                        ></a
                                                    >
                                                </li>
                                                <li
                                                    id="menu-item-50"
                                                    class="menu-item menu-item-type-post_type menu-item-object-page"
                                                >
                                                    <a
                                                        href="https://zadbano.pl/rozwiazania/"
                                                        itemprop="url"
                                                        ><span
                                                            class="avia-bullet"
                                                        ></span
                                                        ><span
                                                            class="avia-menu-text"
                                                            >Rozwiązania</span
                                                        ></a
                                                    >
                                                </li>
                                                <li
                                                    id="menu-item-49"
                                                    class="menu-item menu-item-type-post_type menu-item-object-page"
                                                >
                                                    <a
                                                        href="https://zadbano.pl/wspolpraca/"
                                                        itemprop="url"
                                                        ><span
                                                            class="avia-bullet"
                                                        ></span
                                                        ><span
                                                            class="avia-menu-text"
                                                            >Współpraca</span
                                                        ></a
                                                    >
                                                </li>
                                            </ul>
                                        </li>
                                        <li
                                            id="menu-item-46"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-3"
                                        >
                                            <a
                                                href="https://zadbano.pl/kontakt/"
                                                itemprop="url"
                                                ><span
                                                    class="avia-bullet"
                                                ></span
                                                ><span class="avia-menu-text"
                                                    >Kontakt</span
                                                ><span class="avia-menu-fx"
                                                    ><span
                                                        class="avia-arrow-wrap"
                                                        ><span
                                                            class="avia-arrow"
                                                        ></span></span></span
                                            ></a>
                                        </li>
                                        <li
                                            id="menu-item-53"
                                            class="menu-item menu-item-type-custom menu-item-object-custom av-menu-button av-menu-button-colored menu-item-top-level menu-item-top-level-4"
                                        >
                                            <a href="#" itemprop="url"
                                                ><span
                                                    class="avia-bullet"
                                                ></span
                                                ><span class="avia-menu-text"
                                                    >Szczegóły zlecenia</span
                                                ><span class="avia-menu-fx"
                                                    ><span
                                                        class="avia-arrow-wrap"
                                                        ><span
                                                            class="avia-arrow"
                                                        ></span></span></span
                                            ></a>
                                        </li>
                                        <li
                                            class="av-burger-menu-main menu-item-avia-special"
                                        >
                                            <a
                                                href="#"
                                                aria-label="Menu"
                                                aria-hidden="false"
                                            >
                                                <span
                                                    class="av-hamburger av-hamburger--spin av-js-hamburger"
                                                >
                                                    <span
                                                        class="av-hamburger-box"
                                                    >
                                                        <span
                                                            class="av-hamburger-inner"
                                                        ></span>
                                                        <strong>Menu</strong>
                                                    </span>
                                                </span>
                                                <span
                                                    class="avia_hidden_link_text"
                                                    >Menu</span
                                                >
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                    <!-- end container_wrap-->
                </div>
                <div class="header_bg"></div>

                <!-- end header -->
            </header>
        </div>
    </div>
</template>
<script>
export default {
    name: "pageMenu",
};
</script>



// WEBPACK FOOTER //
// PageMenu.vue?74775a04